class Lottie {
	logoDiv: HTMLElement | null;
	animation: typeof AnimationItem | null;
	isMobile: boolean;
	isHome: boolean;
	hoverHandler: () => void;
	isLoaded: boolean;
	constructor() {
		this.logoDiv = document.querySelector('[data-lottie="logo"]');
		this.isMobile = window.matchMedia('(max-width: 768px)').matches;
		this.isHome = document.body.classList.contains('home');
		this.animation = null;
		this.isLoaded = false;
		this.hoverHandler = this.handleHover.bind(this);
		this.handleMediaQueryChange();
		window
			.matchMedia('(max-width: 768px)')
			.addEventListener('change', this.handleMediaQueryChange.bind(this));
	}

	handleMediaQueryChange() {
		this.isMobile = window.matchMedia('(max-width: 768px)').matches;
		this.init();
	}

	handleHover() {
		if (this.animation) {
			this.animation.goToAndPlay(0, false);
		}
	}

	init() {
		if (this.logoDiv) {
			// Load animation if not already loaded
			if (!this.animation) {
				this.animation = bodymovin.loadAnimation({
					container: this.logoDiv,
					path: '/wp-content/themes/wp-theme-clynk/assets/lottiefiles/logo.json',
					renderer: 'svg',
					autoplay: false,
					loop: false,
					name: 'logo',
				});
			} else {
				this.animation.goToAndStop(0, true);
			}

			// Play on page load if mobile and homepage
			if (this.isMobile && this.isHome) {
				this.animation.goToAndPlay(0, true);
			}

			// Set up hover effect only if not on mobile
			if (!this.isMobile) {
				this.logoDiv.addEventListener('mouseenter', this.hoverHandler);
			} else {
				this.logoDiv.removeEventListener('mouseenter', this.hoverHandler);
			}
		}
	}
}

export default new Lottie();
